import { TextProps } from '@chakra-ui/react';
import useResizeObserver from '@react-hook/resize-observer';
import { FC, useState } from 'react';
import { MText, MTooltip } from './';

interface TruncatedTextProps extends Omit<TextProps, 'children'> {
  children: string;
}

/**
 * Single-line text that ends in an ellipsis when it doesn't fit, and shows the
 * full text in a tooltip only while it is actually cut off.
 */
export const TruncatedText: FC<TruncatedTextProps> = ({
  children,
  ...rest
}) => {
  // Tracked in state, not a ref: toggling the tooltip remounts the text, and
  // the observer has to follow the new element
  const [textElement, setTextElement] = useState<HTMLParagraphElement | null>(
    null,
  );
  const [isTruncated, setIsTruncated] = useState(false);

  useResizeObserver(textElement, ({ target }) => {
    setIsTruncated(target.scrollWidth > target.clientWidth);
  });

  return (
    <MTooltip label={children} isDisabled={!isTruncated}>
      <MText externalRef={setTextElement} truncate {...rest}>
        {children}
      </MText>
    </MTooltip>
  );
};
